import { LAYOUT } from '@/router/constant';
import { AppRouteModule } from '@/router/types';
import { t } from '@/hooks/web/useI18n';

const subject: AppRouteModule = {
    path: '/subject',
    name: 'Subject',
    component: LAYOUT,
    redirect: '/subject/index',
    meta: {
        orderNo: 11,
        icon: 'subject',
        title: t('routes.index.subject.subject'),
    },
    children: [
        {
            path: 'index',
            name: 'SubjectIndex',
            component: () => import('@/views/menu/subject/index.vue'),
            meta: {
                title: t('routes.index.subject.index.index'),
            },
            redirect: '/subject/index/OpenTree',
            children: [
                {
                    path: 'Stable',
                    name: 'SubjectIndexStable',
                    component: () => import('@/views/menu/subject/components/Stable.vue'),
                    meta: {
                        title: t('routes.index.subject.index.stable'),
                    },
                },
                {
                    path: 'Random',
                    name: 'SubjectIndexRandom',
                    component: () => import('@/views/menu/subject/components/Random.vue'),
                    meta: {
                        title: t('routes.index.subject.index.random'),
                    },
                },
                {
                    path: 'Sprint',
                    name: 'SubjectIndexSprintExercise',
                    component: () => import('@/views/menu/subject/components/Sprint.vue'),
                    meta: {
                        title: t('routes.index.subject.index.sprint'),
                    },
                },
                {
                    path: 'SprintFriendPk',
                    name: 'SubjectIndexSprintFriendPk',
                    component: () => import('@/views/menu/subject/components/SprintFriendPk.vue'),
                    meta: {
                        title: t('routes.index.subject.index.sprintFriendPK'),
                    },
                },
                {
                    path: 'OpenTree',
                    name: 'SubjectIndexOpenTree',
                    component: () =>
                        import('@/views/menu/subject/components/OpenTree/OpenTree.vue'),
                    meta: {
                        title: t('routes.index.subject.index.openTree'),
                    },
                },
                {
                    path: 'OpenAiTrain',
                    name: 'SubjectIndexOpenAiTrain',
                    component: () =>
                        import('@/views/menu/subject/components/OpenAiTrain/OpenAiTrain.vue'),
                    meta: {
                        title: t('routes.index.subject.index.OpenAiTrain.OpenAiTrain'),
                    },
                    redirect: '/subject/index/OpenAiTrain/Choose',
                    children: [
                        {
                            path: 'Choose',
                            name: 'SubjectIndexOpenAiTrainChoose',
                            component: () =>
                                import('@/views/menu/subject/components/OpenAiTrain/Choose.vue'),
                            meta: {
                                title: t('routes.index.subject.index.OpenAiTrain.Choose'),
                            },
                        },
                        {
                            path: 'CustomBoard',
                            name: 'SubjectIndexOpenAiTrainCustomBoard',
                            component: () =>
                                import('@/views/menu/subject/components/OpenAiTrain/CustomBoard.vue'),
                            meta: {
                                title: t('routes.index.subject.index.OpenAiTrain.CustomBoard'),
                            },
                        },
                        {
                            path: 'CustomCondition',
                            name: 'SubjectIndexOpenAiTrainCustomCondition',
                            component: () =>
                                import('@/views/menu/subject/components/OpenAiTrain/CustomCondition.vue'),
                            meta: {
                                title: t('routes.index.subject.index.OpenAiTrain.CustomCondition'),
                            },                            
                        },
                        {
                            path: 'Trial',
                            name: 'SubjectIndexOpenAiTrainTrial',
                            component: () =>
                                import('@/views/menu/subject/components/OpenAiTrain/Trial.vue'),
                            meta: {
                                title: t('routes.index.subject.index.OpenAiTrain.Trial'),
                            },
                        },
                        {
                            path: 'Result',
                            name: 'SubjectIndexOpenAiTrainResult',
                            component: () =>
                                import('@/views/menu/subject/components/OpenAiTrain/Result.vue'),
                            meta: {
                                title: t('routes.index.subject.index.OpenAiTrain.Result'),
                            },
                        }
                    ]
                },
            ],
        },
        {
            path: 'payment',
            name: 'SubjectPayment',
            component: () => import('@/views/menu/subject/components/payment.vue'),
            meta: { title: t('routes.index.subject.payment') },
        },
        {
            path: 'history',
            name: 'SubjectHistory',
            component: () => import('@/views/menu/subject/components/OpenAiTrain/History.vue'),
            meta: {
                title: t('routes.index.subject.History')
            }
        }
    ],
};

export default subject;
